import { render, staticRenderFns } from "./ScreenConfigureIntegration.vue?vue&type=template&id=5b9ed084&scoped=true"
import script from "./ScreenConfigureIntegration.vue?vue&type=script&lang=js"
export * from "./ScreenConfigureIntegration.vue?vue&type=script&lang=js"
import style0 from "./ScreenConfigureIntegration.vue?vue&type=style&index=0&id=5b9ed084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ed084",
  null
  
)

export default component.exports